import React, {useState} from 'react';
import AppSideLayout from '../../components/layouts/AppSideLayout';
import {Alert, Button, Card, Input, message, Space, Tooltip} from 'antd';
import Title from 'antd/lib/typography/Title';
import Text from 'antd/lib/typography/Text';
import {UserAddOutlined, HomeOutlined} from '@ant-design/icons';
import './register.less';
import CountDownButton from '../../components/CountDownButton';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {DoubleMemberApi, SavePersonalApproveParams, UserApi, UserDto} from '../../scaffold';
import {useInput} from 'react-hanger';
import PersonalApproveTable from '../../components/user/PersonalApproveTable';
import useAuth from '../../utils/AuthContext';
import {Delay} from '../../utils/delay';
import {useHistory} from 'react-router-dom';
import CommonApiErrorHandler from '../../utils/HttpInstance';

export function Label(props: {required?: boolean; children?: any}) {
  return (
    <Space>
      {props.children}
      {props.required && <Text type={'danger'}>*</Text>}
    </Space>
  );
}

export default function DoubleSelectRegisterPage() {
  const requestSms = useOpenApiFpRequest(UserApi, UserApi.prototype.userRequestSmsCodePost);
  const name = useInput('');
  const password = useInput('');
  const passwordAgain = useInput('');
  const code = useInput('');
  const [loading, _loading] = useState(false);
  const auth = useAuth();
  const history = useHistory();
  const savePersonalApprove = useOpenApiFpRequest(UserApi, UserApi.prototype.userSavePersonalApprovePost);
  const telephoneEmail = useInput('');
  const telephone = useInput('');
  const checkRecordHook = useOpenApiFpRequest(DoubleMemberApi, DoubleMemberApi.prototype.doubleMemberCheckRecordGet);
  const register = useOpenApiFpRequest(UserApi, UserApi.prototype.userRegisterPost);
  const registerDoubleMember = useOpenApiFpRequest(DoubleMemberApi, DoubleMemberApi.prototype.doubleMemberRegisterPost);

  async function onSubmitPersonalApprove(params: SavePersonalApproveParams) {
    _loading(true);
    try {
      const res = await register.request({
        registerParams: {
          telephone: telephone.value,
          password: password.value,
          passwordAgain: passwordAgain.value,
          code: code.value,
        },
      });
      if (res.user) {
        params.userId = res.user?.id || 0;
        auth.setToken(res.body || '');
        auth.setCurrentUser(res.user);
        localStorage.setItem('Application-Token', res.body || '');
        await Delay(1000);
        await savePersonalApprove.request({savePersonalApproveParams: {...params, name: checkRecordHook.data?.name ?? ''}});
        const user: UserDto = await registerDoubleMember.request({
          doubleMemberRegisterModel: {userId: res.user?.id ?? 0, recordId: checkRecordHook.data?.id ?? 0},
        });
        auth.setCurrentUser(user);
        message.success('注册成功');
        history.push('/profile/detail');
      }
    } catch (e) {
      message.error(e.message);
    }
    _loading(false);
  }

  function checkRecord() {
    checkRecordHook
      .request({telephoneEmail: telephoneEmail.value, name: name.value})
      .then(res => {
        telephone.setValue(res.telephone ?? '');
      })
      .catch(CommonApiErrorHandler);
  }

  return (
    <AppSideLayout title={'双选会员'}>
      <Card style={{flex: 1}} title={'双选会员'}>
        <div className={'p-20 text-center'}>
          <Title level={4} className={'m-b-20'}>
            中国计算机学会·上海市计算机学会 <br /> 双选会员账户激活 <br />
          </Title>
          {!checkRecordHook.data && (
            <div>
              <Alert
                showIcon
                style={{width: 500, margin: '0 auto 10px auto'}}
                type={'info'}
                message={'请输入在 中国计算机学会 注册双选会员时的手机号/邮箱及姓名'}
              />
              <table className={'RegisterTable'}>
                <tr>
                  <td width={140}>
                    <Label required>手机号或邮箱</Label>
                  </td>
                  <td width={300}>
                    <Input {...telephoneEmail.eventBind} />
                  </td>
                  <td width={110}>
                    <Label required>姓名</Label>
                  </td>
                  <td>
                    <Input placeholder={'输入姓名'} {...name.eventBind} />
                  </td>
                </tr>
              </table>
              <div className={'text-red-dark'}>{checkRecordHook.errorMessage}</div>
              <Button className={'m-t-10'} type={'primary'} loading={checkRecordHook.loading} onClick={checkRecord}>
                下一步
              </Button>
            </div>
          )}
          {checkRecordHook.data && (
            <div>
              <p>请补充个人信息</p>
              <table className={'RegisterTable'}>
                <tr>
                  <td width={110}>
                    <Label required>手机号</Label>
                  </td>
                  <td width={229}>{checkRecordHook.data?.telephone || <Input placeholder={'输入 11 位手机号'} prefix={'+86'} {...telephone.eventBind} />}</td>
                  <td width={130}>
                    <Label required>验证码</Label>
                  </td>
                  <td>
                    <Space style={{width: '100%'}}>
                      <Input placeholder={'请输入短信验证码'} {...code.eventBind} />
                      <CountDownButton
                        title={'立即获取'}
                        loading={requestSms.loading}
                        onClick={() => requestSms.request({requestSmsCodeParams: {telephone: telephone.value}})}
                        countDown={60}
                      />
                    </Space>
                  </td>
                </tr>
                <tr>
                  <td width={110}>
                    <Label required>密码</Label>
                  </td>
                  <td width={229}>
                    <Input.Password {...password.eventBind} />
                  </td>
                  <td width={130}>
                    <Label required>确认密码</Label>
                  </td>
                  <td>
                    <Input.Password {...passwordAgain.eventBind} />
                  </td>
                </tr>
              </table>
              <PersonalApproveTable name={checkRecordHook.data?.name ?? ''} onSubmit={onSubmitPersonalApprove} loading={loading} />
            </div>
          )}
        </div>
      </Card>
    </AppSideLayout>
  );
}
